var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.345,
    height: 16.958,
    viewBox: "0 0 20.345 16.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu_2_",
    "data-name": "menu (2)",
    transform: "translate(0 -24.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(0 24.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M98.65,24.726H86.568a1.209,1.209,0,0,0-1.208,1.208v1.751a1.209,1.209,0,0,0,1.208,1.208H98.65a1.209,1.209,0,0,0,1.208-1.208V25.934A1.209,1.209,0,0,0,98.65,24.726Z",
    transform: "translate(-79.513 -24.726)",
    fill: "#c2c3cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M98.65,118.087H86.568a1.209,1.209,0,0,0-1.208,1.208v1.751a1.209,1.209,0,0,0,1.208,1.208H98.65a1.209,1.209,0,0,0,1.208-1.208v-1.751A1.209,1.209,0,0,0,98.65,118.087Z",
    transform: "translate(-79.513 -111.692)",
    fill: "#c2c3cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M98.65,211.448H86.568a1.209,1.209,0,0,0-1.208,1.208v1.751a1.209,1.209,0,0,0,1.208,1.208H98.65a1.209,1.209,0,0,0,1.208-1.208v-1.751A1.209,1.209,0,0,0,98.65,211.448Z",
    transform: "translate(-79.513 -198.657)",
    fill: "#c2c3cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M3.149,24.726H1.208A1.209,1.209,0,0,0,0,25.934v1.751a1.209,1.209,0,0,0,1.208,1.208H3.149a1.209,1.209,0,0,0,1.208-1.208V25.934A1.209,1.209,0,0,0,3.149,24.726Z",
    transform: "translate(0 -24.726)",
    fill: "#c2c3cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M3.149,118.087H1.208A1.209,1.209,0,0,0,0,119.295v1.751a1.209,1.209,0,0,0,1.208,1.208H3.149a1.209,1.209,0,0,0,1.208-1.208v-1.751A1.209,1.209,0,0,0,3.149,118.087Z",
    transform: "translate(0 -111.692)",
    fill: "#c2c3cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M3.149,211.448H1.208A1.209,1.209,0,0,0,0,212.656v1.751a1.209,1.209,0,0,0,1.208,1.208H3.149a1.209,1.209,0,0,0,1.208-1.208v-1.751A1.209,1.209,0,0,0,3.149,211.448Z",
    transform: "translate(0 -198.657)",
    fill: "#c2c3cc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.e876e427.svg";
export { ForwardRef as ReactComponent };